import styled from 'styled-components';

import { contentColorMap } from '../../contentColor';
import { fontWeightMap } from '../../fontWeight';
import commonHeadingStyles, { HeadingProps } from '../common/styles';

const H6 = styled.h5.withConfig({
	shouldForwardProp: (prop) => prop !== 'contentColor' && prop !== 'fontWeight',
})<HeadingProps>`
	${commonHeadingStyles};
	font-weight: ${({ fontWeight }) => (fontWeight ? fontWeightMap[fontWeight] : 'normal')};
	font-size: 1.4rem;
	line-height: 133%;
	color: ${({ theme, contentColor }) => (contentColor ? contentColorMap[contentColor](theme) : theme.colors.dark)};

	@media (max-width: ${({ theme }) => theme.breakpoints.md}) {
		font-size: 1rem;
	}
`;

export default H6;
